<span *ngIf="imageSource">
  <img class="barcode-container" [src]="imageSource">
</span>


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/view-request/request-barcode/request-barcode.component.html